export const tipoCargaFilterConfig = [
  {
    id: 'Descricao',
    type: 'text',
    label: 'Descrição',
    placeholder: 'Digite a descrição'
  }
];
